import { render } from "./EsqueciSenha.vue?vue&type=template&id=6ec8d244&scoped=true"
import script from "./EsqueciSenha.vue?vue&type=script&lang=js"
export * from "./EsqueciSenha.vue?vue&type=script&lang=js"

import "./EsqueciSenha.vue?vue&type=style&index=0&id=6ec8d244&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ec8d244"]])

export default __exports__